import { isVisibleDockApplicationPage } from "@/shared/ui/dock-pages";

export const LAST_DOCK_APPLICATION_PATH_KEY = "simon.dock.lastApplicationPath";

export function loadLastDockApplicationPath(): string | null {
  try {
    const path = window.localStorage.getItem(LAST_DOCK_APPLICATION_PATH_KEY);
    return path && isVisibleDockApplicationPage(path) ? path : null;
  } catch {
    return null;
  }
}

export function persistLastDockApplicationPath(path: string): void {
  if (!isVisibleDockApplicationPage(path)) return;
  try {
    window.localStorage.setItem(LAST_DOCK_APPLICATION_PATH_KEY, path);
  } catch {}
}
